<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HtIsam/tc-custom/9781611521153.jpg?1718106103455" alt="This image is the cover for the book Horsing Around"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Horsing Around
      </h1>
      <p class="bookDescription body article font2">
        <p>David Livingston has fallen -- and fallen hard -- for Marcus. With some confusion and a lot of nerves, he's taking Marcus home to the family for Christmas. With a high school sweetheart in the picture, lots of family around, and lots to do, there's not much time for privacy.<br/><br/>Too many pulls on his time and too many emotions swirl away in David's heart. Is he gay? Is this just a one-shot deal with Marcus, just a way to explore a mere curiosity? Or is it something deeper, something that will change his entire life?<br/><br/>David and Marcus have to make some tough choices all in the middle of<em>Horsing Around.</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Diamond
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?453f8f4a